import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-6 justify-center">
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap justify-center">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-white/80 hover:text-white transition-colors duration-200">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <footer className="bg-[oklch(0.20_0.09_240)] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
          {}
          <div className="flex flex-col items-center md:items-start space-y-4">
            <img src="https://alignphysiotherapy.co.uk/wp-content/uploads/2026/01/Align-Logo-1.png" alt="Align Physiotherapy" className="h-7" />
          </div>

          {}
          <div className="flex flex-col items-center space-y-4">
            <h3 className="text-lg font-display font-semibold tracking-wide">Quick Links</h3>
            <MenuProvider menu_id="24">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col items-center md:items-end space-y-4">
            <div className="text-sm text-white/70 text-center md:text-right">
              <p>5 Mill lane, Warmsworth, Doncaster, South Yorkshire, UK, DN4 9RG</p>
              <p className="mt-1">
                <Link to="mailto:appointments@alignphysiotherapy.co.uk" className="hover:text-white transition-colors duration-200">appointments@alignphysiotherapy.co.uk</Link>
              </p>
                <p className="mt-1">
                 <Link to="tel:+447463682889" className="hover:text-white transition-colors duration-200">
                    07463682889
                  </Link>
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} Align Physiotherapy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}